import { call, put, takeLatest } from "redux-saga/effects"

import { ErrorsActions } from "../../Redux/redux/errors.slice"
import { apiGeneratorBase } from "../../Utils/saga"
import Creators, { AdminUsersTypes as constants } from "./reducer"
import * as services from "./services"

const actions = {
  getAdminUsersActions: {
    request: Creators.getAdminUsersRequest,
    success: Creators.getAdminUsersSuccess,
    errors: Creators.getAdminUsersFailure
  },
  getAdminUsersCountActions: {
    request: Creators.getAdminUsersCountRequest,
    success: Creators.getAdminUsersCountSuccess,
    errors: Creators.getAdminUsersCountFailure
  },
  getAdminUsersInviteRolesActions: {
    request: Creators.getAdminUsersInviteRolesRequest,
    success: Creators.getAdminUsersInviteRolesSuccess,
    errors: Creators.getAdminUsersInviteRolesFailure
  },
  getAdminUsersExportActions: {
    request: Creators.getAdminUsersExportRequest,
    success: Creators.getAdminUsersExportSuccess,
    errors: Creators.getAdminUsersExportFailure
  },
  updateAdminUserRoleActions: {
    request: Creators.updateAdminUserRoleRequest,
    success: Creators.updateAdminUserRoleSuccess,
    errors: Creators.updateAdminUserRoleFailure
  },
  inviteAdminUserActions: {
    request: Creators.inviteAdminUserRequest,
    success: Creators.inviteAdminUserSuccess,
    errors: Creators.inviteAdminUserFailure
  },
  resendAdminUserInviteActions: {
    request: Creators.resendAdminUserInviteRequest,
    success: Creators.resendAdminUserInviteSuccess,
    errors: Creators.resendAdminUserInviteFailure
  }
}

const eventsOptions = {
  [constants.GET_ADMIN_USERS_REQUEST]: {
    api: services.getAdminUsers,
    actions: actions.getAdminUsersActions
  },
  [constants.GET_ADMIN_USERS_COUNT_REQUEST]: {
    api: services.getAdminUsersCount,
    actions: actions.getAdminUsersCountActions
  },
  [constants.GET_ADMIN_USERS_INVITE_ROLES_REQUEST]: {
    api: services.getAdminUsersInviteRoles,
    actions: actions.getAdminUsersInviteRolesActions
  },
  [constants.GET_ADMIN_USERS_EXPORT_REQUEST]: {
    api: services.getAdminUsersExport,
    actions: actions.getAdminUsersExportActions
  },
  [constants.UPDATE_ADMIN_USER_ROLE_REQUEST]: {
    api: services.updateAdminUserRole,
    actions: actions.updateAdminUserRoleActions
  },
  [constants.INVITE_ADMIN_USER_REQUEST]: {
    api: services.inviteAdminUser,
    actions: actions.inviteAdminUserActions
  },
  [constants.RESEND_ADMIN_USER_INVITE_REQUEST]: {
    api: services.resendAdminUserInvite,
    actions: actions.resendAdminUserInviteActions
  }
}

function* deleteAdminUserSaga(action) {
  try {
    const id = action.payload
    const response = yield call(services.deleteAdminUser, id)
    if (response.ok) {
      yield put(Creators.deleteAdminUserSuccess(response.data || id))
    } else {
      yield put(Creators.deleteAdminUserFailure())
      yield put(
        ErrorsActions.errorSave(
          response.status === 500 ? "Server response error" : { message: response.data }
        )
      )
    }
  } catch (errors) {
    yield put(Creators.deleteAdminUserFailure())
    yield put(ErrorsActions.errorSave({ errors }))
  }
}

export default function* apiSaga() {
  yield takeLatest(constants.GET_ADMIN_USERS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_ADMIN_USERS_REQUEST])
  )
  yield takeLatest(constants.GET_ADMIN_USERS_COUNT_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_ADMIN_USERS_COUNT_REQUEST])
  )
  yield takeLatest(constants.GET_ADMIN_USERS_INVITE_ROLES_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_ADMIN_USERS_INVITE_ROLES_REQUEST])
  )
  yield takeLatest(constants.GET_ADMIN_USERS_EXPORT_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_ADMIN_USERS_EXPORT_REQUEST])
  )
  yield takeLatest(constants.UPDATE_ADMIN_USER_ROLE_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.UPDATE_ADMIN_USER_ROLE_REQUEST])
  )
  yield takeLatest(constants.INVITE_ADMIN_USER_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.INVITE_ADMIN_USER_REQUEST])
  )
  yield takeLatest(constants.RESEND_ADMIN_USER_INVITE_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.RESEND_ADMIN_USER_INVITE_REQUEST])
  )
  yield takeLatest(constants.DELETE_ADMIN_USER_REQUEST, deleteAdminUserSaga)
}
